module.exports = __webpack_public_path__ + "img/back-arrow-icon.c785fc4c.svg";